import { Button } from '@mui/material';
import { Box } from '@mui/system';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import classes from '../../Style/ButtonsSelect.scss';
import { useState } from 'react';

const ButtonsSelect = (props) => {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleClick = (newIndex) => {
		if (newIndex !== activeIndex) {
			setActiveIndex(newIndex);
			props.onButtonClick(newIndex);
		}
	};

	return (
		<Box
			pt={2}
			pb={2}
			sx={{
				display: 'flex',

				span: { marginTop: '0' }
			}}
			justifyContent={{ xs: 'flex-start', sm: 'center', md: 'center' }}
			className='buttonsSelectWrapper'
		>
			<Button
				onClick={handleClick.bind(this, 0)}
				style={{ color: '#22294D' }}
				startIcon={
					activeIndex === 0 ? (
						<RadioButtonCheckedIcon sx={{ color: '#22294D' }} />
					) : (
						<RadioButtonUncheckedIcon sx={{ color: '#22294D' }} />
					)
				}
			>
				{props.firstButton}
			</Button>
			<Button
				onClick={handleClick.bind(this, 1)}
				style={{ color: 'black' }}
				startIcon={
					activeIndex === 1 ? (
						<RadioButtonCheckedIcon sx={{ color: '#22294D' }} />
					) : (
						<RadioButtonUncheckedIcon sx={{ color: '#22294D' }} />
					)
				}
			>
				{props.secondButton}
			</Button>
		</Box>
	);
};

export default ButtonsSelect;
